import { useEffect } from 'react';

import { metaValues, useAppBranding } from '../../config/branding';

/**
 * Function to handle meta title, description, and favicon
 */
function MetaManager() {
  const { meta: brandMeta } = useAppBranding();

  useEffect(() => {
    const title = brandMeta.title || metaValues.title;
    const description = brandMeta.description || metaValues.description;
    const favicon = brandMeta.favicon || metaValues.favicon;

    // Set meta title
    if (title) {
      document.title = title;
    }

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const newMetaDescription = document.createElement('meta');
      newMetaDescription.name = 'description';
      newMetaDescription.content = description;
      document.head.appendChild(newMetaDescription);
    }

    // Set favicon
    if (favicon) {
      const existingFavicon = document.querySelector("link[rel*='icon']");
      if (existingFavicon instanceof HTMLLinkElement) {
        existingFavicon.href = favicon;
      } else {
        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = favicon;
        document.head.appendChild(newFavicon);
      }
    }
  }, [brandMeta]);

  return null;
}

export default MetaManager;
